export const DOMAIN_FUNCTIONS = 'http://localhost:5001'
